import React, { useEffect, useState } from 'react';
import { getGroups } from '../services/api';
import './PlanningHome.css';

/**
 * PlanningHome Component
 * Toont een lijst van alle plangroepen
 */
const PlanningHome = ({ conneoId, onSelectGroup }) => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Pagina titel instellen
    document.title = 'Conneo Planning';
    
    // Data ophalen
    const fetchGroups = async () => {
      try {
        setLoading(true);
        const response = await getGroups(conneoId);
        
        if (response.meta.status === 'success') {
          // Sorteer groepen op sorteervolgorde
          const sortedGroups = response.data.sort((a, b) => 
            parseInt(a.sort) - parseInt(b.sort)
          );
          setGroups(sortedGroups);
        } else {
          setError('Er is een fout opgetreden bij het ophalen van de plangroepen.');
        }
      } catch (err) {
        console.error('Error fetching groups:', err);
        setError('Er is een fout opgetreden bij het ophalen van de plangroepen.');
      } finally {
        setLoading(false);
      }
    };

    fetchGroups();
  }, [conneoId]);

  if (loading) {
    return <div className="loading">Laden...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="planning-home">
      <div className="group-list">
        {groups.map((group) => (
          <div 
            key={group.objectid} 
            className="group-item"
            onClick={() => onSelectGroup(group)}
          >
            {group.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlanningHome;